<template>
  <form
    class="password-change-form"
    @keyup.enter="onSubmit"
    @submit.prevent="onSubmit"
  >
    <BaseInputPassword
      v-model="password"
      focus
      autocomplete="off"
      autofill="off"
      password-strength
      :placeholder="$tc('regAuthForgot.passwordChangeForm.placeholder')"
      :error-messages="errorMessages.password"
      show-password
      @input="cleanErrors"
    />
    <UiBtn
      submit
      class="password-change-form__button"
      full-width
      size="l"
      color="primary"
      :disabled="formHasDisplayedErrors || isSubmitDisabled"
      :loading="isSubmitDisabled"
      :text="$tc('regAuthForgot.passwordChangeForm.button')"
    />
    <!--Modals-->
    <ThePasswordChangeErrorModal
      :is-show-modal="show.errorModal"
      @close="closeModal"
    />
    <ThePasswordChangeSuccessModal
      :is-show-modal="show.successModal"
      @close="closePasswordChangeModal"
    />
  </form>
</template>

<script>
import { mapActions } from 'vuex'
import BaseInput from '@/components/Base/Input'
import { validationMixin } from 'vuelidate'
import { required, minLength } from 'vuelidate/lib/validators'
import { storageService } from '@/services'
import { passwordValidationErrorMessage } from '@/util/inputValidatonErrorMessage'
import { cyrillic, invalidSymbols } from '~/util/validators/vuelidateValidators.js'
import ThePasswordChangeErrorModal from './ThePasswordChangeErrorModal'
import ThePasswordChangeSuccessModal from './ThePasswordChangeSuccessModal'
import BaseInputPassword from '~/components/Base/Input/Password'

export default {
  name: 'PasswordChangeForm',
  components: {
    BaseInput,
    ThePasswordChangeErrorModal,
    ThePasswordChangeSuccessModal,
    BaseInputPassword,
  },
  mixins: [validationMixin],
  validations() {
    return {
      password: { required, minLength: minLength(6), cyrillic, invalidSymbols },
    }
  },
  data() {
    return {
      password: '',
      /** submitting */
      isSubmitDisabled: false,
      /** modals */
      show: {
        errorModal: false,
        successModal: false,
      },
      /** errors handle */
      errorMessages: {
        password: [],
      },
    }
  },
  computed: {
    formHasDisplayedErrors() {
      return Boolean(this.errorMessages.password.length)
    },
  },
  beforeDestroy() {
    storageService.removeToken()
    this.closeModal()
  },
  methods: {
    ...mapActions('login', ['restore_passwordForm', 'act_isSuccessPasswordChange']),
    passwordValidationErrorMessage,
    cleanErrors() {
      this.errorMessages.password = []
    },
    updateErrors() {
      this.errorMessages.password = []
      if (this.$v.$invalid) {
        if (this.$v?.password.$error) {
          this.errorMessages.password = this.passwordValidationErrorMessage(this.$v.password)
        }
      }
    },
    async onSubmit() {
      if (this.isSubmitDisabled || this.formHasDisplayedErrors) return
      this.isSubmitDisabled = true
      this.$v.$touch()
      this.updateErrors()
      if (this.$v.$invalid) {
        this.isSubmitDisabled = false
        return
      }
      try {
        const res = await this.restore_passwordForm({
          password: this.password,
          password2: this.password,
        })
        if (res.status) {
          this.isSubmitDisabled = false
          this.show.successModal = true
          await this.act_isSuccessPasswordChange(true)
        }
        else {
          if (
            res.errors === 'Unauthorized'
            || res.errors === 'passwords_is_not_equals'
          ) {
            this.isSubmitDisabled = false
            this.show.errorModal = true
          }
          if (res.errors.password === 'bad_password') {
            this.errorMessages.password.push(
              this.$t('forms.errors.maxPassword')
            )
          }
        }
      }
      catch (error) {
        this.isSubmitDisabled = false
      }
    },
    closePasswordChangeModal() {
      this.closeModal()
      this.$newModal.changeQueryParam('bigModal', 'auth')
    },
    closeModal() {
      this.show.errorModal = false
      this.show.successModal = false
    },
  },
}
</script>

<style lang="scss" src="./style.scss"></style>
